module.exports = __webpack_public_path__ + "img/phone_cropped_transparent.a1acb7fd.png";